import { Col, Row, Image } from 'antd';
import React, { ReactElement } from 'react';
import Panel from '../../../shared/components/card/Panel';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { GUTTOR_SPACE, GUTTOR_SPACE_SMALL } from '../../../shared/constants/commonConstants';
import { ReactComponent as MailIcon } from '../../../assets/images/svg/i_mail.svg';

const NewsAndAnnouncements = (): ReactElement => {
  const data = ['1.jpg', '2.jpg', '3.jpg', '4.jpg', '5.png', '6.png', '7.png', '8.png'];

  return (
    <>
       <PageHeader colSize={18}
        pageTitle="News and Announcements"
      />
      <div className="ant-tabs-content-holder tab-custom-container resources">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16}>
            <Panel title="Announcements" className="help">
              <Image.PreviewGroup>
                <Row gutter={GUTTOR_SPACE}>
                  {data.map((d: any, nIndex: number): ReactElement =>
                    <Col key={nIndex} className="announcement-col">
                      <span className="ant-image-wrapper">
                        <Image src={`${process.env.REACT_APP_COMMON_BUCKET_URL}resources-image/${d}`} />
                      </span>
                    </Col>,
                  )}
                </Row>
              </Image.PreviewGroup>
            </Panel>
          </Col>
          <Col md={8}>
            <Panel title="Reach us">
              <Row gutter={GUTTOR_SPACE_SMALL}>
                <Col md={24}> <a href="mailto:care@ihx.in">
                  <MailIcon className="fill-primary v-align-middle" /> care@ihx.in</a></Col>
              </Row>
            </Panel>
          </Col>
        </Row>
      </div>
      </>
  );
};

export default NewsAndAnnouncements;
